function openChatPopup() {
  is_close = false;
  if( document.querySelector('#wrchat-container') && document.querySelector('#wrchat-container').classList.contains('closed') ) {
    is_close = true;
  } 
  
  is_button_present = false;
  if( document.querySelector('#wrchat-iframe') && document.querySelector('#wrchat-iframe').contentDocument.querySelector('.chat-icon-main') ) {
    is_button_present = true;
  } 

  if(is_close && is_button_present) {
    document.querySelector('#wrchat-iframe').contentDocument.querySelector('.chat-icon-main').click();
  } 
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.expert_link_wrap a, .product__info-wrapper .expert_chat_wrap').forEach((elem) => {
    elem.addEventListener('click', (evt) => {
      evt.preventDefault();
      openChatPopup();
    });
  });
});